/*
 * @Descripttion: 文本相关的伪代码
 * @Author: shenah
 * @Date: 2023-04-19 09:19:42
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-11-08 09:46:39
 */
import { eventTemp } from "_dataview/output/utils/relativeEvent";
export default {
  props: {
    // 主标题
    title: {
      type: String,
      default: "标题",
    },
    // 主标题颜色
    titleColor: {
      type: String,
      default: "#FFF",
    },
    titleFontFamily: {
      type: String,
      default: "Microsoft Yahei",
    },
    // 主标题字体大小
    titleFontSize: {
      type: String,
      default: "20",
    },
    // 主标题字体粗细
    titleIsBold: {
      type: Boolean,
      default: true,
    },
    mainTitleAlgin: {
      type: String,
      default: "left",
    },
    // 主标题边距
    titlePadding: {
      type: Array,
      default: () => [0, 0, 0, 0],
    },
    subTitle: {
      type: String,
      default: "",
    },
    subTitleColor: {
      type: String,
      default: "#FFF",
    },
    subTitleFontSize: {
      type: String,
      default: "16",
    },
    subTitleIsBold: {
      type: Boolean,
      default: false,
    },
    subTitleAlgin: {
      type: String,
      default: "left",
    },
    subTitlePadding: {
      type: Array,
      default: () => [0, 0, 0, 0],
    },
    //存在事件依赖
    hasEventRelative: {
      type: Boolean,
      default: true,
    },
    //事件依赖
    eventRelativeDeal: {
      type: Object,
      default() {
        return {
          click: {
            relatives: [],
            fn: eventTemp,
          },
        };
      },
    },
  },
  data() {
    return {
      componentType: "text",
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.handleEventScope();
    });
  },
  methods: {
    //标题点击事件
    clickItem(text) {
      this.$dispatch("clickItem", text);
      this.loadClickEvents(text);
    },
    //依赖组件关联方法
    loadClickEvents(data) {
      let { fn } = this.eventRelativeDeal.click;
      this.handleCommonEmit(fn, data);
    },
    setTitleEvent(str) {
      if (str) {
        this.$emit("update:title", str);
      }
      return this;
    },
    setSubTitleEvent(str) {
      if (str) {
        this.$emit("update:subTitle", str);
      }
      return this;
    },
  },
};
